module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("1. "), _c('em', [_vm._v("KATAL!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("2. SIGNS OF VIOLENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("POORIE")]), _vm._v(" AND "), _c('em', [_vm._v("MUDRAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("4. THE MISSING CLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("5. THE LIE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("6. THE STEEL BRACELET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("7. A GRIM ADDRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("8. DEAD END")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("9. PRIVATE INVESTIGATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("10. DANGEROUS GAME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("11. NIGHT WATCH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("12. A LIFE AT STAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("13. THE WITNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("14. CAUGHT!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("15. LIFE LINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_vm._v("16. THE CAPTIVE’S STORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_vm._v("17. THE YELLOW HAWK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c18.htm"
    }
  }, [_vm._v("18. ATTACK!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c19.htm"
    }
  }, [_vm._v("19. WIND AND WATER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c20.htm"
    }
  }, [_vm._v("20. "), _c('em', [_vm._v("KATAL")]), _vm._v(" AGAIN")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0